import {useContext, useEffect} from 'react';

import {CarouselProviderContext} from '#component/provider/CarouselProvider';

export function useCarousel(args?: {slideWidth: number; gap: number}) {
  const carouselContext = useContext(CarouselProviderContext);

  useEffect(() => {
    if (args?.slideWidth && !carouselContext?.slideWidth) {
      carouselContext.setSlideWidth(args.slideWidth);
      carouselContext.setGap(args.gap);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [args?.slideWidth, args?.gap]);

  return carouselContext;
}
